import React from 'react';
import PropTypes from 'prop-types';
import { ResponsiveImage } from '@web/molecules';
import { useReporter } from '../../reporter';
import { ctaButtonClicked } from './events';
import {
  Section,
  Media,
  DesktopImage,
  MobileImage,
  Copy,
  CopyInner,
  Header,
  SubHeader,
  OllieAppButtonsContainer,
} from './styles.js';

export const AppCtaComponent = ({
  heading,
  subheading,
  image,
  mobileImage,
  appLinks,
  level,
}) => {
  const reporter = useReporter();
  const hasMobileImage = Boolean(mobileImage?.src);
  return (
    <Section>
      <Media>
        {hasMobileImage ? (
          <MobileImage>
            <ResponsiveImage {...mobileImage} objectFit="cover" />
          </MobileImage>
        ) : null}
        <DesktopImage $hasMobile={hasMobileImage}>
          <ResponsiveImage {...image} objectFit="cover" />
        </DesktopImage>
      </Media>
      <Copy>
        <CopyInner>
          {heading && <Header as={level}>{heading}</Header>}
          {subheading && <SubHeader>{subheading}</SubHeader>}
          <OllieAppButtonsContainer>
            {appLinks
              ?.filter(({ link }) => Boolean(link))
              .map(({ image: badge, link }, i) => (
                <a
                  key={i}
                  href={link}
                  target="_blank"
                  rel="noreferrer"
                  onClick={() =>
                    reporter.tag(ctaButtonClicked(link, heading || subheading))
                  }
                >
                  <ResponsiveImage
                    src={badge.src}
                    alt={badge.alt}
                    height={badge.height ?? 64}
                    width={badge.width ?? 224}
                  />
                </a>
              ))}
          </OllieAppButtonsContainer>
        </CopyInner>
      </Copy>
    </Section>
  );
};

AppCtaComponent.displayName = 'AppCtaComponent';

AppCtaComponent.propTypes = {
  heading: PropTypes.string,
  subheading: PropTypes.string,
  image: PropTypes.object.isRequired,
  mobileImage: PropTypes.object,
  appLinks: PropTypes.arrayOf(
    PropTypes.shape({
      link: PropTypes.string,
      image: PropTypes.object.isRequired,
    }),
  ),
  level: PropTypes.oneOf(['h1', 'h2', 'h3', 'h4', 'h5', 'h6']),
};
